import React, { useState } from 'react';
import { apiPost } from '../contexts/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Button } from './ui/button';
import { toast } from 'sonner';

/** Lets a partner replace a generated (e-mailed) password with their own. */
export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const close = (o) => { if (!o) { setForm({ current: '', next: '', confirm: '' }); setError(''); } onOpenChange(o); };

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 8) { setError('The new password must be at least 8 characters.'); return; }
    if (form.next !== form.confirm) { setError("The new passwords don't match."); return; }
    setError('');
    setSaving(true);
    try {
      await apiPost('/auth/change-password', { current_password: form.current, new_password: form.next });
      toast.success('Password changed');
      close(false);
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const field = (k, id, text, autoComplete) => (
    <div className="space-y-2">
      <Label htmlFor={id}>{text}</Label>
      <Input id={id} type="password" value={form[k]} onChange={set(k)} autoComplete={autoComplete} required className="h-11" />
    </div>
  );

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="sm:max-w-md" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle style={{ fontFamily: 'Outfit' }}>Change password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          {error && <div role="alert" className="p-3 bg-danger/10 border border-danger/30 rounded-lg text-danger text-sm">{error}</div>}
          {field('current', 'cp-current', 'Current password', 'current-password')}
          {field('next', 'cp-new', 'New password (at least 8 characters)', 'new-password')}
          {field('confirm', 'cp-confirm', 'Confirm new password', 'new-password')}
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={() => close(false)}>Cancel</Button>
            <Button type="submit" disabled={saving} className="bg-brand hover:bg-brand-soft text-white" data-testid="change-password-submit">
              {saving ? 'Saving…' : 'Change password'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
